module.exports = __webpack_public_path__ + "img/icon-soundoff.df91e5b.svg";